import React from 'react'
import './Table.scss'

export const Table = ({ children }) => {
    return (
        <table className='ic-data-table'>
            {children}
        </table>
    )
}

const Thead = ({ children }) => {
    return (
        <thead>
            <tr>
                {children}
            </tr>
        </thead>
    )
}

const Tbody = ({ children }) => {
    return (
        <tbody>
            {children}
        </tbody>
    )
}

const Th = ({ titleSameAsContent, ...props }) => {
    return (
        <th {...props} title={props.titleSameAsContent ? props.children : ''}>{props.children}</th>
    )
}

const Td = ({ titleSameAsContent, ...props }) => {
    return (
        <td {...props} title={props.titleSameAsContent ? props.children : ''}>{props.children}</td>
    )
}

export {
    Thead, Tbody, Th, Td
}
